export default {
	
	
	// 开发环境start
	//urlDev:'http://192.168.3.34:9011/admin',
	urlDev:'https://applet-api.muebabyspa.com/admin',//线上地址
	// urlDev:'https://applet-api-test.muebabyspa.com/admin',//测试地址
	// 开发环境end
	
	
	
	
	
	// 线上环境start
	urlPro:'https://applet-api.muebabyspa.com/admin',//线上地址
	// urlPro:'https://applet-api-test.muebabyspa.com/admin',//测试地址
	// 线上环境end
	

	 datetimePickeOption: {
	    shortcuts: [
	      {
	        text: '1 week',
	        value () {
	          const end = new Date()
	          const start = new Date()
	          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
	          return [start, end]
	        }
	      },
	      {
	        text: '1 month',
	        value () {
	          const end = new Date()
	          const start = new Date()
	          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
	          return [start, end]
	        }
	      },
	      {
	        text: '3 months',
	        value () {
	          const end = new Date()
	          const start = new Date()
	          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
	          return [start, end]
	        }
	      }
	    ]
	  },
	  
	  
	  
	  
};